import { Grid } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";

import { FormatAmount } from "../../Components/Formatters/AmountFormat";
import {
  OnlyDateConverter,
  // OnlyTimeConverter,
  convertTo12Hour
} from "../../Components/Helpers/DateTimeConverter";
import PSCLogo from "../../Assets/Logo/PSCLogo.jpg";
import { useParams } from "react-router-dom";
import { GetPublicURL, PostMethod, GetMethod } from "../../Helper/api";
import { GreenColorButton } from "../../Components/MaterialButtonStyle/StyleButton"; 
import LoaderModal from "../../Components/Modal/Loader"
const OfferLetterModal = ({ applicationCopyDetails }) => {
  const targetRef = useRef();
  const params = useParams();
  const [useProfile, setuseProfile] = useState();
  const [CharmansSignatures, setusesProfile] = useState();
  const [CharmanName, setCharmanName] = useState();
  const [CandidateDetail, setCandidateDetail] = useState();
  const [applicationDetail, setapplicationDetail] = useState();
  const [ShowLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (applicationDetail?.applicant_image) {
      AdminConvertbase64(applicationDetail.applicant_image);
    }
  }, [CandidateDetail, applicationDetail]);

  useEffect(() => {
    if (params?.id) {
      GetApplicationDetails(params.id);
    }
    GetCharmenSignatures();
  }, []);
  const GetCharmenSignatures = async () => {
    try {
      let url = "settings/signatureslist";
      let method = "GET";
      const response = await GetMethod({ url, method });
      if (response.status) {
        if (response.result[0].signature_file) {
          AdminConvertbase641(response.result[0].signature_file);
        }
        setCharmanName(response.result[0].signature_name);
      }
    } catch (Error) {
      console.log("Error in GetCharmenSignatures", Error);
    }
  };
  const GetApplicationDetails = async (id) => {
    try {
      let url = "test/viewapplications";
      let method = "POST";
      let params = {
        job_application_uuid: id,
      };
      setShowLoader(true)
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        
        if (response?.jobapplication[0]) {
          setapplicationDetail(response.jobapplication[0]);
        }
        if (response.jobapplication[0]?.applicant_temp_details) {
          let data = response.jobapplication[0]?.applicant_temp_details;
          const formattedArray = [
            data.reduce((result, item) => {
              const sanitizedKey = item.name.replace(/\s+/g, ""); // Remove spaces from the key
              result[sanitizedKey] = item.value; // Assign the value to the sanitized key
              return result;
            }, {}),
          ];
          setCandidateDetail(formattedArray[0]);
        }
        setShowLoader(false)
      }else{
        setShowLoader(false)
      }
    } catch (Error) {
      setShowLoader(false)
      console.log("Error", Error);
    }
  };
  const AdminConvertbase64 = async (image) => {
    try {
      let images = await GetPublicURL(image);
      fetch(images, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const source = URL.createObjectURL(blob);
          setuseProfile(source);
        })
        .catch((error) => console.error("Error fetching image:", error));
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const AdminConvertbase641 = async (image) => {
    try {
      let images = await GetPublicURL(image);
      fetch(images, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const source = URL.createObjectURL(blob);
          setusesProfile(source);
        })
        .catch((error) => console.error("Error fetching image:", error));
    } catch (Error) {
      console.log("Error", Error);
    }
  };

  const handlePrint = () => {
    // Find and hide the button
    const buttonToHide = document.querySelector(".hide-on-print");
    if (buttonToHide) buttonToHide.style.display = "none";
    window.print();
    if (buttonToHide) buttonToHide.style.display = "block";
  };
  return (
    <Grid lg={12} style={{ padding: 50, backgroundColor: "#fff" }}>
      <Grid item lg={10} ref={targetRef} l md={12} sm={12} xs={12}>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          border={"1px solid #666666"}
        >
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            className="p-3"
            borderBottom={"1px solid #666666"}
          >
            <Grid
              item
              lg={2}
              sm={4}
              md={4}
              xs={4}
              container
              justifyContent={"center"}
            >
              <img
                src={PSCLogo}
                alt="PSCLogo"
                height={80}
                width={80}
                className="img_fluid"
              />
            </Grid>

            <Grid
              item
              lg={10}
              sm={8}
              md={8}
              xs={8}
              container
              alignItems={"center"}
              flexDirection={"column"}
            >
              <h className="poppinsSemiBold Text-Prime-Black my-1">
                Police Service Commission
              </h>
              <p className="poppinsRegular Text-Prime-Gray">
                Corporate Headquarters, Plot 64, Cadastral Zone B16, Sector
                Centre B, Jabi, Abuja
              </p>
              <p className="poppinsRegular Text-Prime-Gray">
                Website: https://psc.gov.ng/
              </p>
            </Grid>
          </Grid>
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            className="p-2"
            container
            justifyContent={"center"}
          >
            <h5 className="poppinsSemiBold Text-Prime-Black">
              Offer of Employment for{" "}
              {applicationDetail?.job_name ? applicationDetail?.job_name : ""}
              {/* {applicationDetail?.job_post ? applicationDetail?.job_post : ""} */}
              {/* {applicationDetail?.job_name ? applicationDetail?.job_name : ""} */}
            </h5>
          </Grid>
        </Grid>
        <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2">
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            justifyContent={"flex-end"}
          >
            <p className="poppinsSemiBold Text-Prime-Black">
              Date:{" "}
              <span className="poppinsRegular Text-Prime-Black">
                {applicationDetail?.job_updated_on
                  ? OnlyDateConverter(applicationDetail?.job_updated_on)
                  : "-"}
              </span>
            </p>
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className="p-2"
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Grid
            item
            lg={9}
            sm={9}
            md={9}
            xs={9}
            container
            alignItems={"center"}
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              className="py-2"
              flexDirection={"column"}
            >
              <p className="poppinsSemiBold Text-Prime-Black text-left">To,</p>
              <p className="poppinsRegular Text-Prime-Black text-left">
                {CandidateDetail?.Title}
                {CandidateDetail?.Surname
                  ? CandidateDetail?.Surname + " " + CandidateDetail?.LastName
                  : "--"}
              </p>
              <p className="poppinsRegular Text-Prime-Black text-left">
                {CandidateDetail?.PermanentHomeAddress
                  ? CandidateDetail.PermanentHomeAddress
                  : "--"}
              </p>
              <p className="poppinsRegular Text-Prime-Black text-left">
                {CandidateDetail?.MainPhoneNumber
                  ? "+234 " + CandidateDetail?.MainPhoneNumber
                  : "--"}
              </p>
            </Grid>
          </Grid>
          <Grid
            item
            lg={2}
            sm={2}
            md={2}
            xs={2}
            container
            justifyContent={"center"}
          >
            <img
              src={useProfile}
              alt="PSCLogo"
              height={150}
              width={150}
              className="img_fluid"
            />
            <p className="poppinsSemiBold Text-Prime-Black">
              Application Number
            </p>
            <p className="poppinsRegular Text-Prime-Black ">
              {" "}
              {applicationDetail?.application_serial
                ? applicationDetail?.application_serial
                : "--"}
            </p>
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          alignItems={"flex-start"}
          flexDirection={"column"}
          className="p-2"
        >
          <p className="poppinsSemiBold Text-Prime-Black pt-2"> Subject:</p>
          <p className="poppinsRegular Text-Prime-Black ">
            {" "}
            Official Offer of Employment for the Role of Cadet Sub Inspector –
            Welcome to Your New Journey with the Nigerian Police Force and
            Congratulations on Your Outstanding Achievement During the
            Recruitment Process
          </p>
          <p className="poppinsSemiBold Text-left Text-Prime-Black pt-2">
            {" "}
            Position Details:{" "}
          </p>
          <div>
            <ul className="text-left ">
              <li>
                <p className="poppinsSemiBold Text-Prime-Black">
                  {" "}
                  Job Role:
                  <p className="poppinsRegular Text-Prime-Black">
                    {applicationDetail?.job_name
                      ? applicationDetail?.job_name
                      : "--"}
                    {/* {applicationDetail?.job_post
                      ? applicationDetail?.job_post
                      : "--"} */}
                  </p>
                </p>{" "}
              </li>
              <li>
                <p className="poppinsSemiBold Text-Prime-Black ">
                  Job Location:
                  <p className="poppinsRegular Text-Prime-Black">
                    {applicationDetail?.job_location
                      ? applicationDetail?.job_location
                      : "--"}
                  </p>
                </p>
              </li>
              <li>
                <p className="poppinsSemiBold Text-Prime-Black ">
                  Job Start Date:
                  <p className="poppinsRegular Text-Prime-Black">
                    {applicationDetail?.job_start_date
                      ? applicationDetail?.job_start_date
                      : "-"}
                  </p>
                </p>
              </li>
            </ul>
          </div>

          <p className="poppinsSemiBold Text-Prime-Black pt-2">
            {" "}
            Salary & Benefits:{" "}
          </p>
          <p className="poppinsRegular Text-Prime-Black ">
            As a  {applicationDetail?.job_name ? applicationDetail?.job_name : ""}, you will receive a monthly salary of ₦
            {applicationDetail?.job_salary
              ? FormatAmount(applicationDetail.job_salary)
              : "-"}{" "}
            per month, and the following benefits:
          </p>
          <ul>
            <li>
              <p className="poppinsRegular Text-Prime-Black text-left">
                Comprehensive health insurance coverage for you and your
                immediate family
              </p>{" "}
            </li>
            <li>
              <p className="poppinsRegular Text-Prime-Black text-left">
                Retirement plan options with company matching contributions
              </p>{" "}
            </li>
            <li>
              <p className="poppinsRegular Text-Prime-Black text-left">
                Paid time off including annual leave and public holidays
              </p>
            </li>
            <li>
              <p className="poppinsRegular Text-Prime-Black text-left">
                Opportunities for professional development and training programs
              </p>
            </li>
          </ul>
          <p className="poppinsSemiBold Text-Prime-Black pt-2 text-left">
            {" "}
            Employment Terms:{" "}
          </p>
          <p className="poppinsRegular Text-Prime-Black text-left">
            Your employment will be governed by the following terms:
          </p>
          <div>
            <ul>
              <li>
                <p className="poppinsSemiBold Text-Prime-Black text-left">
                  Probation Period:
                  <p className="poppinsRegular Text-Prime-Black text-left ">
                    {applicationDetail?.job_probation
                      ? applicationDetail.job_probation
                      : "-"}{" "}
                    months
                  </p>
                </p>{" "}
              </li>
              <li>
                <p className="poppinsSemiBold Text-Prime-Black text-left">
                  Work Hours:
                  <p className="poppinsRegular Text-Prime-Black ">
                    {" "}
                    {applicationDetail?.working_hours
                      ? convertTo12Hour(applicationDetail.working_hours) +
                        " - " +
                        convertTo12Hour(applicationDetail.working_hours_to)
                      : "-"}
                  </p>
                </p>
              </li>
              <li>
                <p className="poppinsSemiBold Text-Prime-Black text-left">
                  Duties:
                  <p className="poppinsRegular Text-Prime-Black ">
                    {applicationDetail?.primary_duties
                      ? applicationDetail?.primary_duties
                      : "---"}
                    .
                  </p>
                </p>
              </li>
            </ul>
          </div>
          <p className="poppinsSemiBold Text-Prime-Black pt-2"> Acceptance:</p>
          <p className="poppinsRegular Text-Prime-Black">
            Please indicate your acceptance of this offer by signing and
            returning a copy of this letter by{" "}
            {applicationCopyDetails?.appliedOn
              ? OnlyDateConverter(applicationCopyDetails?.appliedOn)
              : "-"}
            . For any questions, please contact{" "}
            {applicationCopyDetails?.CreatedBy
              ? applicationCopyDetails?.CreatedBy
              : "-"}{" "}
            at{" "}
            {applicationCopyDetails?.CreateorContactNumber
              ? applicationCopyDetails?.CreateorContactNumber
              : "-"}{" "}
            or{" "}
            {applicationCopyDetails?.CreatorMail
              ? applicationCopyDetails.CreatorMail
              : "-"}
          </p>
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className="p-3"
          justifyContent={"center"}
          border={"1px solid #666666"}
        >
          <p className="poppinsRegular Text-Prime-Black">
            Congratulations on your appointment, and welcome to the Nigerian
            Police Service Commission.
          </p>
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className="p-3"
          justifyContent={"flex-end"}
        >
          <Grid
            item
            lg={3}
            sm={3}
            md={3}
            xs={3}
            container
            flexDirection={"column"}
            alignItems={"center"}
          >
            <p className="poppinsRegular Text-Prime-Black pb-2 text-center">
              With Regards,
            </p>
            <img
              src={CharmansSignatures}
              alt="Signature"
              height={80}
              width={160}
              className="img_fluid"
            />
            <p className="poppinsSemiBold Text-Prime-Black pt-2 text-center">
              {CharmanName ? CharmanName : ""}
            </p>
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className="p-3"
          justifyContent={"center"}
        >
          <Grid
            item
            lg={3}
            sm={3}
            md={3}
            xs={3}
            container
            flexDirection={"column"}
            alignItems={"center"}
          >
            <GreenColorButton
              type="submit"
              className="hide-on-print px-3 py-2 ml-3"
              onClick={() => handlePrint()}
            >
              print
            </GreenColorButton>
          </Grid>
        </Grid>
      </Grid>
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
    </Grid>
  );
};

export default OfferLetterModal;
